import { createFileRoute } from "@tanstack/react-router";
import FounderBusinessContinuity from "@/pages/FounderBusinessContinuity";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/accelerator/business-continuity/")({
  component: () => (
    <RoleGate allow={['founder', 'staff']} area="Business Continuity"><FounderBusinessContinuity /></RoleGate>
  ),
});
